export default "__VITE_ASSET__Cp_V3SKO__"